<script>
import Endpoints from '../../components/common/Endpoints';
import Common from '../../components/common/Common';
import Request from '../../components/common/Request';
import { mapActions } from 'vuex'

export default {
    init: async (payload) => {
        const el = document.body;
        el.removeAttribute("class");

    },
    methods:{
        filter: function(){
            $('#spinner').modal('toggle');
            if(this.plate){
                Request.do(this, 'GET', Request.getDefaultHeader(this), null,`${Endpoints.sinesp.search}` + '?plate=' + this.plate.replace('-',''),
                (response)=>{//SUCCESS CALLBACK

                    this.item = response;
                    $('#spinner').modal('toggle');
                },
                (error)=>{//ERROR CALLBACK
                });

            }
        
        },
        camelize: Common.toUpperCase,
    }
}
</script>
